module.exports = __webpack_public_path__ + "assets/img/2.60400527.jpg";